import { render, staticRenderFns } from "./caseReference.vue?vue&type=template&id=3e0b9dbf&scoped=true&"
import script from "./caseReference.vue?vue&type=script&lang=js&"
export * from "./caseReference.vue?vue&type=script&lang=js&"
import style0 from "./caseReference.vue?vue&type=style&index=0&id=3e0b9dbf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0b9dbf",
  null
  
)

export default component.exports